<template>
  <div :class="$style.container">
    <div
      v-if="logoLink"
      :class="$style.logoImage"
      :style="getStyle"
    />
    <div
      v-else
      :class="$style.logoEmpty"
      v-text="logoEmptyText"
    />
  </div>
</template>

<script>
export default {
  name: 'ProjectLogo',
  props: {
    logoLink: String,
    projectName: String,
  },
  computed: {
    logoEmptyText() {
      if (this.$validate.isNotString(this.projectName)) {
        return null;
      }

      return this.projectName.charAt(0).toUpperCase();
    },
    getStyle() {
      return { backgroundImage: `url(${this.logoLink})` };
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +size(100%)
    +flexbox
    +align-items(center)
    +justify-content(center)
    max-width: 60px
    max-height: 60px
    background-color: rgb(173, 227, 251)
    border-radius: 50%
    overflow: hidden

  .logoImage
    +covered-image

  .logoEmpty
    +font-type(semi-bold, 24, 30)
    color: rgba(33, 33, 33, 0.25)
</style>
